import type { IconSvgObject } from './types';

const FlaskConicalOffIcon: IconSvgObject = [
  ["path", { d: "M9.5 4.5V2M14.5 9.5V2M9.31429 9.31429L3.21843 19.6303C3.07543 19.8723 3 20.1483 3 20.4294C3 21.2968 3.7032 22 4.57063 22H19C19.8111 22 20.5094 21.5172 20.8232 20.8232", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 2H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17 17C14 17 11 14 8 14C7.65244 14 7.31998 14.0181 7 14.0512", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FlaskConicalOffIcon;
